import { OrgRole, isOrgRoleSuperset } from "@hex/common";

import { useCurrentUser } from "./useCurrentUser.js";

/**
 * Returns true if the current user is the provided role or above.
 */
export const useCurrentUserIsRoleOrAbove = (role: OrgRole): boolean => {
  return useCurrentUser({
    selector: (user) => {
      if (!user) return false;
      return isOrgRoleSuperset(user.orgRole, role);
    },
  });
};
